
import { Component, Vue } from 'vue-property-decorator';
import Themeable from 'vuetify/lib/mixins/themeable';
import { ProfileRepositoryInterface } from '@/services/Users-profile/interfaces';
import { ProfileMapInterface } from '@/services/QC-V2/chat/interfaces';
import DossierUserRepositoryInterface, { AgentInterface } from '@/services/Dossier/user/interfaces';
import DossierPositionRepositoryInterface, { AgentPositionInterface } from '@/services/Dossier/position/interfaces';

interface PositionInterface {
  id: number,
  name: string,
  agents: AgentInterface[],
}

@Component({
  mixins: [
    Themeable,
  ],
  inject: [
    'dossierUserRepository',
    'dossierPositionRepository',
    'profileRepository',
  ],
})
export default class AllAgents extends Vue {
  private dossierUserRepository!: DossierUserRepositoryInterface;
  private dossierPositionRepository!: DossierPositionRepositoryInterface;
  private profileRepository!: ProfileRepositoryInterface;

  private loading: boolean = true;

  private users: AgentInterface[] = [];
  private positionsResponse: AgentPositionInterface[] = [];

  private positions: PositionInterface[] = [];

  private profilesMap: ProfileMapInterface = {};

  private async created(): Promise<void> {
    await this.initialize();
  }

  private async initialize(): Promise<void> {
    try {
      this.positionsResponse = await this.dossierPositionRepository.getAllPositions();
      this.users = await this.dossierUserRepository.getAllUsers();
      await this.getAgentsProfiles();
      this.transformData();
      this.loading = false;
    } catch (e) {
      this.$errorDialog.show(e?.response?.data?.message || e.message);
    }
  }

  private async getAgentsProfiles(): Promise<void> {
    const profiles = await this.profileRepository.getBaseProfileDataByUsersIds(this.users.map((user) => user.id));

    profiles.forEach((profile) => {
      this.profilesMap[profile.userId] = profile;
    });
  }

  private transformData(): void {
    this.positions = this.positionsResponse.map((position) => ({
      ...position,
      agents: this.users.filter((user) => user.position.id === position.id),
    }));
  }

  private async addAgent(): Promise<void> {
    await this.$router.push({ name: 'add-agent' });
  }

  private async agentProfileRedirect(agentId: string): Promise<void> {
    await this.$router.push({ name: 'agent-profile', params: { userId: agentId } });
  }

  private async updateAgent(userId: string): Promise<void> {
    await this.$router.push({ name: 'update-agent', params: { userId } });
  }
}
